module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1055-219a6700c41111b0dc18e05da514575d.png";